if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.querySelectorAll('.addtocart-variant')
            .forEach(variant => variant.addEventListener('click', this.addToCartVariant.bind(this)));
      this.querySelectorAll('.ctl-card__size-select')
            .forEach(select => select.addEventListener('change', this.onCtlSizeSelect.bind(this)));

      // Ordinamento delle taglie nel product card
      window.sortSize('.product-form__variant', '.product-form__variants', '.card-wrapper');
      window.sortSize('.product-form__variant', '.product-form__variants', '.ctl-card');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      this.cartNotification.setActiveElement(document.activeElement);

      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton) {
        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('loading');
      }
      const body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          this.cartNotification.renderContents(parsedState);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
          }
        });
    }

    addToCartVariant(event) {
      const currentVariant = event.currentTarget;
      this.form.querySelector('input[name="id"').value = currentVariant.getAttribute('data-value');
      this.onSubmitHandler(event);
    }

    /**
     * Syncs the mobile Complete the look size select with the hidden variant input.
     * @param {Event} event
     */
    onCtlSizeSelect(event) {
      const select = event.currentTarget;
      const hiddenInput = this.form.querySelector('input[name="id"]');
      const submitButton = this.querySelector('.ctl-card__submit');
      const selectedOption = select.selectedOptions[0];
      const variantId = select.value;

      if (hiddenInput) hiddenInput.value = variantId;

      if (submitButton) {
        submitButton.disabled = !variantId || (selectedOption && selectedOption.disabled);
      }
    }
  });
}
